import React, {useState} from 'react';
import PropTypes from 'prop-types';
import SecGroupComparison from './secGroupComparison/secGroupComparison';

const SecGroupContainer = (props) => {

  const [securityGroupInput1, updateSecurityGroupInput1] = useState('');
  const [securityGroupInput2, updateSecurityGroupInput2] = useState('');

  const securityGroups = props.securityGroups;

  const {chosenGroups} = props;

  const selectedGroup1 = securityGroups.find(group => group.GroupId === chosenGroups[0]);
  const selectedGroup2 = securityGroups.find(group => group.GroupId === chosenGroups[1]);

  const handleEnterPress1 = e => {
    if (e.keyCode === 13) {
      setTimeout(handleAddToCompare1, 0);
    };
  };

  const handleEnterPress2 = e => {
    if (e.keyCode === 13) {
      setTimeout(handleAddToCompare2, 0);
    };
  };

  const handleAddToCompare1 = () => {
    const groupId1 = securityGroupInput1.match(/.+? - .+? - (.+)/)[1];
    console.log(groupId1);
    props.updateParentState({groupId1});
  };

  const handleAddToCompare2 = () => {
    const groupId2 = securityGroupInput2.match(/.+? - .+? - (.+)/)[1];
    props.updateParentState({groupId2});
  };

  return (
    <div className="SecGroupContainer">
      <div className="SecGroupHeader">
        <p>{securityGroups.length === 0 ? 'Fetching security groups...' :'Security Group to Compare'}</p>
        <input
          list="securityGroups"
          name="securityGroupInput1"
          value={securityGroupInput1}
          onChange={e => updateSecurityGroupInput1(e.target.value)}
          onKeyDown={handleEnterPress1}
          placeholder="Search..."
        />
        <datalist id="securityGroups">
          {securityGroups.map(securityGroup => {
            return <option key={`option-${securityGroup.GroupId}`} value={`${securityGroup.OwnerName} - ${securityGroup.GroupName} - ${securityGroup.GroupId}`}></option>;
          })}
        </datalist>
        <button onClick={handleAddToCompare1}>Monitor</button>
        {/* <p>Selected Group: {selectedGroup1 && `${selectedGroup1.GroupId} - ${selectedGroup1.GroupName}`}</p> */}
        <p>{securityGroups.length === 0 ? 'Fetching security groups...' :'Security Group to Compare'}</p>
        <input
          list="securityGroups"
          name="securityGroupInput2"
          value={securityGroupInput2}
          onChange={e => updateSecurityGroupInput2(e.target.value)}
          onKeyDown={handleEnterPress2}
          placeholder="Search..."
        />
        <datalist id="securityGroups">
          {securityGroups.map(securityGroup => {
            return <option key={`option-${securityGroup.GroupId}`} value={`${securityGroup.GroupId} - ${securityGroup.GroupName}`}></option>;
          })}
        </datalist>
        <button onClick={handleAddToCompare2}>Monitor</button>
        {/* <p>Selected Group: {selectedGroup2 && `${selectedGroup2.GroupId} - ${selectedGroup2.GroupName}`}</p> */}
      </div>
      <div className="GroupTitles">
        <h2 className="GroupTitle">{selectedGroup1 ? `${selectedGroup1.GroupName} - ${selectedGroup1.GroupId}` : 'Select A Group'}</h2>
        <h2 className="GroupTitle">{selectedGroup2 ? `${selectedGroup2.GroupName} - ${selectedGroup2.GroupId}` : 'Select A Group'}</h2>
      </div>
      <div className="SecGroupInfo">
        <SecGroupComparison/>
      </div>
    </div>
  );

};

SecGroupContainer.propTypes = {
  securityGroups: PropTypes.array,
  updateParentState: PropTypes.func
};

export default SecGroupContainer;


// WEBPACK FOOTER //
// ./src/components/content/securityGroupComparer/secGroupContainer/secGroupContainer.js